module.exports = __webpack_public_path__ + "img/img-1.d53ba5e7.jpeg";